import commonLogout from '@core_utils/common-logout';

export default {
    // name: 'common-logout-mixin',
    data: () => ({}),
    created () {},
    mounted () {},
    methods: {
        // 세션 만료(401) 처리 — 로그아웃 후 /?redirect=<현재 주소>&reason=session 으로 한 번만 보낸다
        // (인터셉터와 같은 진행 중 Promise 를 공유해 복귀 주소가 '/' 로 덮이지 않는다)
        commonLogout () {
            return commonLogout()
        }
    }
}
